import { getAPIHeaders } from '@/services/api.service';

function mapSubscription(item) {
    return item
        ? {
              ...item,
              proposedAt: item.proposedAt ? new Date(item.proposedAt) : null,
              firstPaymentAt: item.firstPaymentAt ? new Date(item.firstPaymentAt) : null,
              signedAt: item.signedAt ? new Date(item.signedAt) : null,
              validatedAt: item.validatedAt ? new Date(item.validatedAt) : null,
              createdAt: item.createdAt ? new Date(item.createdAt) : null,
              createdBy: item.createdBy ? new Date(item.createdBy) : null,
              updatedAt: item.updatedAt ? new Date(item.updatedAt) : null,
              updatedBy: item.updatedBy ? new Date(item.updatedBy) : null,
              startDate: item.startDate ? new Date(item.startDate) : null,
              endDate: item.endDate ? new Date(item.endDate) : null,
          }
        : null;
}

export async function removeSubscription(subscription) {
    const response = await fetch(
        new Request(`/api/subscriptions/${subscription.id}`, {
            method: 'DELETE',
            headers: getAPIHeaders(),
        }),
    );
    return response.json();
}

export async function createSubscription(subscription) {
    const response = await fetch(
        new Request(`/api/subscriptions`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(subscription),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('createSubscription failed');
    }
}

export async function updateSubscription(subscription) {
    const response = await fetch(
        new Request(`/api/subscriptions/${subscription.id}`, {
            method: 'PUT',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(subscription),
        }),
    );
    return mapSubscription(await response.json());
}
export async function generateSubscriptionTemplate(subscription) {
    const response = await fetch(
        new Request(`/api/subscriptions/${subscription.id}/templateFile`, {
            method: 'PUT',
            headers: getAPIHeaders(),
        }),
    );
    return mapSubscription(await response.json());
}

export async function getSubscriptions() {
    const response = await fetch(`/api/subscriptions`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).map(mapSubscription);
}
export async function getSubscription(subscriptionId) {
    const response = await fetch(`/api/subscriptions/${subscriptionId}`, {
        headers: getAPIHeaders(),
    });
    return mapSubscription(await response.json());
}
